module.exports = __webpack_public_path__ + "img/IMG_2028.fff01eda.jpg";